import { Injectable } from '@angular/core';
import { MenuOptions } from './menu-options';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor() { }

  loadAll(): MenuOptions[] {
    return [
      new MenuOptions("Home",'welcome'),
      new MenuOptions("Education",'education'),
      new MenuOptions("Skills",'skills'),
      new MenuOptions("Work Experience",'experience')
    ]
  }
}
